import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule, NgComponentOutlet } from '@angular/common';
import { IAuthModalComponent, IAuthModalPresenter } from './interfaces';
import { IAbstractView } from '@core/interfaces';
import { AuthModalPresenter } from './auth-modal.presenter';
import { DialogComponent } from '@shared/components';
@Component({
	selector: 'app-auth-modal',
	templateUrl: './auth-modal.component.html',
	styleUrls: ['./auth-modal.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: true,
	imports: [
		CommonModule,
		NgComponentOutlet,
		DialogComponent
	],
})
export class AuthModalComponent extends IAbstractView<IAuthModalPresenter> implements IAuthModalComponent {
	translations = this.presenter.translations;
	selectedComponent = this.presenter.selectedComponent;
	strategy = this.presenter.strategy;
	dialogTitle = this.presenter.dialogTitle;

	@Input() visitingCheckout = this.presenter.visitingCheckout;
	@Input() initialComponent?: import('./enums').AuthModalComponentEnum;

	constructor(presenter: AuthModalPresenter) {
		super(presenter);
	}

	onClose(): void {
		this.presenter.onClose();
	}

	onContinueAsGuest(): void {
		this.presenter.onContinueAsGuest();
	}
}
